var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pessoas"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('v-form',[_c('PageTitle',{attrs:{"icon":"mdi-pencil-box-outline","main":"Compras e serviços","sub":"Processos","home":"/compras"}}),_c('div',[_c('processo')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }